import { useSearchParams } from 'react-router-dom';
import { WorkspaceTabs } from './Workspace';
import type { ReactNode } from 'react';
export function useWorkspaceView(key: string, values: readonly string[], fallback: string) {
  const [params, setParams] = useSearchParams();
  const requested = params.get(key);
  const value = requested && values.includes(requested) ? requested : fallback;
  const select = (next: string) => { if (!values.includes(next)) return; const updated = new URLSearchParams(params); updated.set(key, next); setParams(updated); };
  return [value, select] as const;
}
export function WorkspaceViews({ label, queryKey, fallback, sections }: { label: string; queryKey: string; fallback: string; sections: { value: string; label: string; content: ReactNode }[] }) {
  const [value, select] = useWorkspaceView(queryKey, sections.map(section => section.value), fallback);
  return <><WorkspaceTabs label={label} value={value} options={sections} onChange={select} />{sections.map(section => <section key={section.value} role="tabpanel" aria-label={section.label} hidden={value !== section.value}>{section.content}</section>)}</>;
}
